module.exports = new Promise((resolve, reject) => {
          var url = window.__MBC_MFE_REMOTE_URL__
          if (!url) {
            reject(new Error('MBC_MFE_REMOTE_URL is not configured'))
            return
          }
          import(/* webpackIgnore: true */ url).then(function (mod) {
            resolve({
              get: function (request) { return mod.get(request) },
              init: function (arg) {
                try { return mod.init(arg) }
                catch (e) { /* container already initialized */ }
              }
            })
          }).catch(reject)
        });